import React from 'react';

import { IBlogPost } from '../../../types/contentful';

import { PageProps } from '../../context/PageData';

import { Body } from '../Body';
import { MorePosts } from './MorePosts';

export function BlogPost({ blogPostData, query }: PageProps) {
  const { fields, sys } = (blogPostData as IBlogPost) ?? {};

  return fields ? (
    <Body {...fields} query={query} pathPrefix="/blog">
      <MorePosts sysId={sys?.id} />
    </Body>
  ) : null;
}
